
import Vue from 'vue';
import { trackCardClick } from '~/utility/tracking';

export default Vue.extend({
  props: {
    category: {
      type: String,
      default: 'Referenzen',
    },
    date: {
      type: Object,
      default: () => ({
        dateValue: '03.09.2022',
      }),
    },
    text: {
      type: null as any,
      default: 'News',
    },
    image: {
      type: Object,
    },
    sizes: {
      type: String,
      default: 'xs:92vw lg:46vw',
    },
    link: {
      type: Object,
      default: () => ({
        url: '/',
      }),
    },
    subtags: {
      type: Array,
      default: () => [],
    },
    // Used for a11y adjustments
    disableLinks: {
      type: Boolean,
      default: false,
    },
    // Optional: Position of the card in a list
    position: {
      type: Number,
      default: undefined,
    },
  },

  computed: {
    getSubTags(): string {
      return this.subtags.join(' · ');
    },
  },

  methods: {
    handleCardClick(event: MouseEvent): void {
      // Track immediately, even if navigation is prevented
      if (process.client) {
        trackCardClick(this.category, this.text, this.link.url, this.subtags as string[], this.position);
      }
    },
  },
});
